import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { Box, Icon } from '@mui/material'
import { Theme } from '@mui/material/styles'

const ICON_SIZE = { width: 20, height: 20 }

const TreeView = (theme: Theme) => {
  return {
    MuiTreeView: {
      defaultProps: {
        defaultCollapseIcon: (
          <RemoveCircleOutlineIcon
            width={ICON_SIZE.width}
            height={ICON_SIZE.height}
          />
        ),
        defaultExpandIcon: (
          <AddCircleOutlineIcon
            width={ICON_SIZE.width}
            height={ICON_SIZE.height}
          />
        ),
        defaultEndIcon: (
          <Box
            component={Icon}
            width={ICON_SIZE.width}
            height={ICON_SIZE.height}
            sx={{ color: 'text.secondary' }}
          />
        ),
      },
    },
    MuiTreeItem: {
      styleOverrides: {
        label: { ...theme.typography.body2 },
        iconContainer: { width: 'auto' },
      },
    },
  }
}

export default TreeView
